export enum ObjType {
	GEO = 'geo',
	CUBE_CAMERA = 'cubeCamera',
	AUDIO_LISTENER = 'audioListener',
	POSITIONAL_AUDIO = 'positionalAudio',
	SCENE = 'scene',
}
